export const blogDe = {
  // Blog page
  blogHeroTitle: "SheCan Geschichten",
  blogHeroSubtitle: "Echte Frauen. Echte Stärke. Echte Geschichten.",
  latestArticles: "Neueste Artikel",
  readMore: "Weiterlesen",
  byAuthor: "Von",
  
  // Categories
  empowerment: "Ermächtigung",
  career: "Karriere",
  wellness: "Wohlbefinden",
  relationships: "Beziehungen",
  personalGrowth: "Persönliches Wachstum",
  inspiration: "Inspiration",
  mothersWisdom: "Mutters Weisheit",
  grandmothersLetters: "Briefe von Großmüttern"
};

export default blogDe;
